import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 448 512"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M321.7 0c19.1 0 32.9 18.3 27.6 36.6L295.8 224H381c19.3 0 34.9 15.6 34.9 34.9 0 10.3-4.5 20-12.3 26.6L144.9 505.2c-5.2 4.4-11.8 6.8-18.6 6.8-19.1 0-32.9-18.3-27.6-36.6L152.2 288H65.7C47.1 288 32 272.9 32 254.3c0-9.9 4.3-19.2 11.8-25.6L303.1 6.9c5.2-4.5 11.8-6.9 18.6-6.9m-36.1 85L104.4 240H184c7.5 0 14.6 3.5 19.2 9.5s6 13.8 3.9 21l-44.8 157L345.5 272H264c-7.5 0-14.6-3.5-19.2-9.5s-6-13.8-3.9-21z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }